import axios from "axios";
import config from "../config/config";
import globals from "./globals";

export default function apiService() {
  var t3Services = "";
  var baseUrl = "";

  function addAuthorizationHeader(dbName) {
    var currentUser = globals().getLogedInUser();
    if (dbName) {
      currentUser.company = dbName
    }

    baseUrl = config?.baseUrl + currentUser?.company + "/mapi";

    axios.defaults.headers.common["userid"] = `${currentUser?.data?.id || 0}`;
    axios.defaults.headers.common["Authorization"] = `Bearer ${currentUser?.data?.token || ""
      }`;

    console.log("currentUser:", currentUser);
  }

  return {
    test() {
      alert("test function");
    },
    async getDatabases(tableName) {
      t3Services = config?.baseUrl + "t3services@t3/mapi";
      addAuthorizationHeader();
      //baseUrl = config.baseUrl + config.company + '/mapi';
      return await axios.get(t3Services + `/${tableName}`).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    async queryT3Services(queryName, params) {
      //addAuthorizationHeader();
      var t3Services = config?.baseUrl + "t3services@t3/mapi";
      return await axios
        .get(t3Services + `/query/${queryName}?${params}`)
        .then((response) => {
          //console.log(response.data);
          return response.data;
        });
    },
    async queryT3Logins(queryName, params) {
      //addAuthorizationHeader();
      var t3logins = config?.baseUrl + "t3logins/mapi";
      return await axios
        .get(t3logins + `/query/${queryName}?${params}`)
        .then((response) => {
          //console.log(response.data);
          return response.data;
        });
    },
    async putT3Logins(tableName, obj, db) {
      var t3logins = config?.baseUrl + db + "/mapi";
      return await axios.put(t3logins + `/${tableName}`, obj).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    async getT3Logins(tableName) {
      var t3logins = config?.baseUrl + "t3logins/mapi";
      //baseUrl = config.baseUrl + config.company + '/mapi';
      return await axios.get(t3logins + `/${tableName}`).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    get(tableName) {
      addAuthorizationHeader();
      //baseUrl = config.baseUrl + config.company + '/mapi';
      return axios.get(baseUrl + `/${tableName}`).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    getById(tableName, id) {
      addAuthorizationHeader();
      return axios.get(baseUrl + `/${tableName}/${id}`).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    search(name, params) {
      addAuthorizationHeader();

      if (!params) {
        params = "";
      }
      return axios
        .get(baseUrl + `/search/${name}/?${params}`)
        .then((response) => {
          //console.log(response.data);
          return response.data;
        });
    },
    post(tableName, obj, dbName) {
      addAuthorizationHeader(dbName);
      return axios.post(baseUrl + `/${tableName}`, obj).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    query(queryName, params) {
      addAuthorizationHeader();
      return axios
        .get(baseUrl + `/query/${queryName}?${params}`)
        .then((response) => {
          //console.log(response.data);
          return response.data;
        });
    },
    execute(queryName, params, method = 'get') {
      addAuthorizationHeader();
      if (method && method === 'post') {
        return axios
          .post(baseUrl + `/query/${queryName}`, params)
          .then((response) => {
            //console.log(response);
            return response.data;
          });
      } else if (method && method === 'get') {
        return axios
          .get(baseUrl + `/execute/${queryName}?${params}`)
          .then((response) => {
            //console.log(response.data);
            return response.data;
          });
      }
    },
    put(tableName, obj) {
      addAuthorizationHeader();
      return axios.put(baseUrl + `/${tableName}`, obj).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    delete(tableName, id) {
      addAuthorizationHeader();
      return axios.delete(baseUrl + `/${tableName}/${id}`).then((response) => {
        //console.log(response.data);
        return response.data;
      });
    },
    saveChanges(objs) {
      addAuthorizationHeader();
      return axios.put(baseUrl + `/savechanges`, objs).then((response) => {
        //console.log(response);
        return response.data;
      });
    },
    uploadFile(obj) {
      let logedInUser = globals().getLogedInUser();
      addAuthorizationHeader();
      baseUrl = `http://localhost:3003/${logedInUser?.company}/upload`;
      return axios.post(baseUrl, { image: obj }).then((response) => {
        return response;
      });
    },
    arbk(number) {
      addAuthorizationHeader();
      return axios.get(`https://t3next.com/arbk/search?numri=${number}`).then(response => response.data);
    },
    async getCountries() {
      try {
          const response = await fetch("http://api.geonames.org/countryInfoJSON?username=cimi");

          if (!response.ok) {
              throw new Error(`Gabim: ${response.status} - ${response.statusText}`);
          }

          const data = await response.json();
          console.log("✅ Të dhënat e marra:", data.geonames);

          return data?.geonames.map((country) => ({
              name: country.countryName,
              code: country.countryCode,
          }));
      } catch (error) {
          console.error("❌ Gabim gjatë marrjes së të dhënave:", error);
          return null;
      }
  },
  postConfirmation(obj) {
    addAuthorizationHeader();
    console.log(obj);
    //return axios.post("http://localhost:3003/sendemail", obj).then((response) => {
    return axios.post("https://t3next.com/t3admin.api/sendemail1", obj).then((response) => {
      return response.data;
    });
  },
  async getCitiesByCountry(countryCode) {
      try {
          if (countryCode !== "XK") {
              const response = await fetch(`http://api.geonames.org/searchJSON?country=${countryCode}&featureClass=P&maxRows=1000&username=cimi&lang=auto`);

              if (!response.ok) {
                  throw new Error("Nuk u kthyen të dhëna për qytetet.");
              }

              const data = await response.json();
              console.log(data)
              return data?.geonames.map((city, index) => ({
                  name: city.toponymName,
                  no: index + 1
              }));
          } else {
              const response = axios.get(`https://t3next.com/arbk/qytetet-kosove`).then(response => response.data);
              console.log(response)
              return response;
          }

      } catch (error) {
          console.error("❌ Gabim gjatë marrjes së qyteteve:", error);
          return [];
      }
  }
  };
}
